import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';
import { translate } from '../../../common/translation/translate';

export const StoryReadMore = memo(({ isFirstStory, translateKey, link }) => {
    return <Container isFirstStory={isFirstStory} href={link}>{`${translate(translateKey)}`}</Container>;
});

StoryReadMore.displayName = 'StoryReadMore';

StoryReadMore.propTypes = {
    isFirstStory: PropTypes.bool,
    translateKey: PropTypes.string,
    link: PropTypes.string
};

const Container = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 16px;
    color: rgb(85, 85, 85);
    cursor: pointer;
    ${({isFirstStory}) => isFirstStory ?
        `@media ${smallMediaQuery} {
            margin-top: 7px;
            height: 18px;
        }
        @media ${mediumMediaQuery} {
            height: 7%;
        }
        @media ${largeMediaQuery} {
            height: 5%;
            font-size: 16px;
        }`
        :
        `line-height: 22px;
        width: 100%;
        height: 25%;
        @media ${largeMediaQuery} {
            height: 20%;
        }`
    }
`;


